import { makeStyles, createStyles, Theme } from '@maas-components/core';
import shell, { StyleProps } from '../theme';

const styles = (theme: Theme) => {
    return createStyles({
        container: {
            display: 'flex',
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column',
                paddingTop: theme.spacing(3),
            },
        },
        menuFavoritesTitle: {
            color: (props: StyleProps) => shell[props.mode].menu.textTitle,
            marginLeft: theme.spacing(0),
            [theme.breakpoints.down('sm')]: {
                marginLeft: theme.spacing(2),
            },
        },
        addFavoritesLabel: {
            fontSize: '14px',
            color: '#0086FF',
            marginLeft: theme.spacing(1),
        },
        storeLinkIconColor: {
            color: (props: StyleProps) => shell[props.mode].menu.text,
        },
        storeLinkContainer: {
            margin: 0,
            display: 'flex',
            [theme.breakpoints.down('sm')]: {
                alignItems: 'center',
                justifyContent: 'flex-start',
                marginTop: theme.spacing(2),
                marginRight: theme.spacing(2),
            },
        },
        storeLinkText: {
            color: (props: StyleProps) => shell[props.mode].menu.text,
            fontSize: '16px',
            marginLeft: theme.spacing(1),
            textDecoration: 'none',
            '&:visited': {
                color: '#424A52',
            },
        },
        menuItemTitle: {
            color: (props: StyleProps) => shell[props.mode].menu.textTitle,
            marginLeft: 44,
            [theme.breakpoints.down('sm')]: {
                marginLeft: theme.spacing(2),
            },
        },
        menuItemIcon: {
            color: (props: StyleProps) => shell[props.mode].menu.icon,
            minWidth: theme.spacing(4),
        },
        favoriteContainer: {
            margin: 0,
            [theme.breakpoints.down('sm')]: {
                marginBottom: theme.spacing(1),
            },
        },
        favoriteContent: {
            marginRight: theme.spacing(3),
        },
        menuItemsContainer: {
            paddingLeft: theme.spacing(1),
            [theme.breakpoints.down('sm')]: {
                marginTop: theme.spacing(2),
                paddingLeft: '0',
            },
            [theme.breakpoints.down('md')]: {
                overflow: 'auto',
                height: '64vh',
            },
            [theme.breakpoints.down('lg')]: {
                overflow: 'auto',
                height: '64vh',
            },
        },
        menuItemContent: {
            margin: 0,
            display: 'flex',
            [theme.breakpoints.down('sm')]: {
                margin: 0,
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                display: 'flex',
                padding: '0px 16px',
            },
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column',
            },
        },
        menuList: {
            margin: 0,
            padding: 0,
            width: '50%',
        },
        menuItemFavorite: {
            display: 'flex',
            width: '100%',
            minHeight: theme.spacing(6),
            margin: 0,
            padding: 0,
            color: (props: StyleProps) => shell[props.mode].menu.textTitle,
            [theme.breakpoints.down('sm')]: {
                marginLeft: theme.spacing(2),
            },
        },
        menuItem: {
            display: 'flex',
            width: '100%',
            minHeight: theme.spacing(6),
            margin: 0,
            padding: 0,
            color: (props: StyleProps) => shell[props.mode].menu.textTitle,
            [theme.breakpoints.down('sm')]: {},
        },
        menuItemHover: {
            [theme.breakpoints.up('sm')]: {
                '& > div > button': {
                    visibility: 'hidden',
                },
                '&:hover': {
                    '& > div > button': {
                        visibility: 'visible',
                    },
                },
            },
        },
        removeFavorites: {
            display: 'none',
        },
        addFavorites: {
            display: 'block',
            minWidth: 44,
        },
        menuLink: {
            width: '100%',
            textDecoration: 'none',
            color: (props: StyleProps) => shell[props.mode].menu.text,
            '&:visited': {
                color: (props: StyleProps) => shell[props.mode].menu.text,
            },
        },
        selectedMenu: {
            '& > span': {
                fontWeight: 'bold',
            },
        },
        menuItemText: {
            marginLeft: theme.spacing(2),
        },
        anchorPositionTop: {
            backgroundColor: (props: StyleProps) => shell[props.mode].menu.background,
            top: theme.spacing(9),
            padding: theme.spacing(3),
            borderBottomLeftRadius: '10px',
            borderBottomRightRadius: '10px',
        },
        anchorPositionLeft: {
            backgroundColor: (props: StyleProps) => shell[props.mode].menu.background,
            top: theme.spacing(7),
        },
        drawerContainer: {
            margin: '0 auto',
            width: '1024px;',
            [theme.breakpoints.down('sm')]: {
                width: '100%',
            },
        },
        newChip: {
            backgroundColor: '#0086FF',
            height: theme.spacing(3),
            borderRadius: 3,
            color: '#fff',
            marginLeft: theme.spacing(4),
        },
        favoriteInfo: {
            color: '#788089',
        },
        infoIcon: {
            width: theme.spacing(1),
            marginRight: '4px',
        },
        infoText: {
            color: (props: StyleProps) => shell[props.mode].menu.text,
            [theme.breakpoints.down('sm')]: {
                marginLeft: theme.spacing(2),
            },
        },
        removeFavoriteIcon: {
            color: theme.palette.error.light,
            [theme.breakpoints.down('sm')]: {
                marginRight: theme.spacing(2),
            },
        },
        menuLinksMobile: {
            marginTop: theme.spacing(1),
            padding: theme.spacing(0, 2),
        },
        menuLinksItemMobile: {
            marginTop: theme.spacing(1),
        },
        iconOtherApps: {
            marginLeft: theme.spacing(1),
        },
    });
};

export default makeStyles(styles, { name: 'MuiShellMenu' });
